<a routerLink="/features" i18n="@@button-more-feature" class="button-ghost-gray-with-arrow-top">
    More Features
    <companyid-arrow color="black" position="top-right" />
</a>

<hr class="border border-solid border-gray-3 my-5px" />
<a routerLink="/pricing" i18n="@@button-see-prices" class="button-ghost-gray-with-arrow-top">
    See Prices
    <companyid-arrow color="black" position="top-right" />
</a>
